
<footer class="bg-[#F9F8F6] footer-container font-rubik">
  <div class="w-full h-full flex flex-row justify-center">
    <div class="w-full h-full max-w-1440">
      <div class="flex flex-col 1350-bp:grid 1350-bp:grid-cols-4 w-full border-none footer-sections-container">
        <div class="col-span-1 flex flex-col">
          <div class="h-1/4 1350-bp:h-1/2 flex items-start 1350-bp:justify-center justify-start border border-[#E0DAD1] py-10 pl-4 1350-bp:pt-10 1350-bp:pl-0 1350-bp:py-0 border-b-0">
            <a :href="rootPath">
              <img @click="goToHome()" class="logo-image cursor-pointer pt-1" src="@/images/container_alliance_logo.svg" alt="container alliance logo">
            </a>
          </div>
          <div class="h-3/4 1350-bp:h-1/2 border border-[#E0DAD1] 1350-bp:border-t-0">
            <google-maps :apiKey="googleMapsApiKey" class=" 1350-bp:hidden h-full w-full map-container" />
          </div>
        </div>
        <div class="col-span-3 flex flex-col">
          <!-- First half -->
          <div class="w-full h-full flex flex-col">
            <!-- P01 -->
            <div class="flex flex-col 1350-bp:flex-row">
              <div class="flex items-start justify-center pt-5 1350-bp:pt-10 pb-5 w-full border border-[#E0DAD1]">
                <div class="w-full p01-first-half-container">
                  <h3 class="ft-box-title">Customer Guides</h3>
                  <ul>
                    <li><a class="text-footerLinks ft-box-links" :href="containerBuyersGuideUrl">Container Buyers Guide</a></li>
                    <li><a class="text-footerLinks ft-box-links" :href="refrigeratedBuyersGuideUrl">Refrigerated Buyers Guide</a></li>
                    <li><a class="text-footerLinks ft-box-links" :href="containerRentalGuideUrl">Container Rental Guide</a></li>
                    <li><a class="text-footerLinks ft-box-links" :href="refrigeratedRentalGuideUrl">Refrigerated Rental Guide</a></li>
                  </ul>
                </div>
              </div>
              <div class="flex items-start justify-center pt-5 1350-bp:pt-10 pb-5 w-full border border-[#E0DAD1]">
                <div class="w-full p01-first-half-container">
                  <h3 class="ft-box-title">Solutions</h3>
                  <ul>
                    <li><a class="text-footerLinks ft-box-links" :href="containerSalesUrl">Container Sales</a></li>
                    <li><a class="text-footerLinks ft-box-links" :href="containerRentalsUrl">Container Rentals</a></li>
                    <li><a class="text-footerLinks ft-box-links" :href="refrigeratedContainersUrl">Refrigerated Containers</a></li>
                    <li><a class="text-footerLinks ft-box-links" :href="portableOfficesUrl">Portable Offices</a></li>
                    <li><a class="text-footerLinks ft-box-links" :href="soluctionContainerModificationsUrl">Container Modifications</a></li>
                    <li><a class="text-footerLinks ft-box-links" :href="accessoriesUrl">Container Alliance Accessories</a></li>
                  </ul>
                </div>
              </div>
              <div class="flex items-start justify-center pt-5 1350-bp:pt-10 pb-5 w-full border border-[#E0DAD1]">
                <div class="w-full p01-first-half-container">
                  <h3 class="ft-box-title">Resources</h3>
                  <ul>
                    <li><a class="text-footerLinks ft-box-links" :href="resourcesContainerModificationsUrl">Container Modifications</a></li>
                    <li><a class="text-footerLinks ft-box-links" :href="deliveryInformationUrl">Delivery Information</a></li>
                    <li><a class="text-footerLinks ft-box-links" :href="containerConditionsUrl">Container Conditions</a></li>
                    <li><a class="text-footerLinks ft-box-links" :href="shippingContainerSpecificationsUrl">Container Specifications</a></li>
                  </ul>
                </div>
              </div>
            </div>
            <!-- P02 -->
            <div class="flex flex-col 1350-bp:flex-row h-full">
              <div class="flex items-start justify-center pt-5 1350-bp:pt-10 pb-5 w-full border border-[#E0DAD1]">
                <div class="w-full p01-first-half-container">
                  <h3 class="ft-box-title">Company</h3>
                  <ul>
                    <li><a class="text-footerLinks ft-box-links" :href="aboutUsUrl">About Us</a></li>
                    <li><a class="text-footerLinks ft-box-links" :href="serviceAreaUrl">Our Services</a></li>
                    <li><a class="text-footerLinks ft-box-links" :href="resourcesContainerModificationsUrl">Container Modifications</a></li>
                    <li><a class="text-footerLinks ft-box-links" :href="partnerProgramUrl">Partner Program</a></li>
                  </ul>
                </div>
              </div>
              <div class="flex items-start justify-center pt-5 1350-bp:pt-10 pb-5 w-full border border-[#E0DAD1]">
                <div class="w-full p01-first-half-container">
                  <h3 class="ft-box-title">Contact</h3>
                  <ul>
                    <li>
                      <a class="text-footerLinks ft-box-links" href="/contact"> Contact Us</a>
                    </li>
                    <li><a class="text-footerLinks ft-box-links" data-vue-init="zip-code-modal" data-props='{"isTypeChange": true}'>Find Inventory</a></li>
                    <li><a class="text-footerLinks ft-box-links" href="mailto: info@containeralliance.com">info@containeralliance.com</a></li>
                  </ul>
                </div>
              </div>
              <div class="flex items-start justify-center pt-5 1350-bp:pt-10 pb-5 w-full border border-[#E0DAD1]">
                <div class="w-full p01-first-half-container">
                  <h3 class="ft-box-title">Social</h3>
                  <ul>
                    <li class="flex">
                      <img class="social-link-icons" src="@/images/header/social/facebook-logo.svg" alt="facebook">
                      <a class="text-footerLinks ft-box-links" :href="facebookUrl">Facebook</a>
                    </li>
                    <li class="flex">
                      <img class="social-link-icons" src="@/images/header/social/instagram-logo.svg" alt="Instagram">
                      <a class="text-footerLinks ft-box-links" :href="instagramUrl">Instagram</a>
                    </li>
                    <li class="flex">
                      <img class="social-link-icons" style="width: 17px; height: 24px;" src="@/images/social-media/X.svg" alt="X">
                      <a class="text-footerLinks ft-box-links" :href="twitter">X</a>
                    </li>
                    <li class="flex">
                      <img class="social-link-icons" src="@/images/header/social/linkedin-logo.svg" alt="LinkedIn">
                      <a class="text-footerLinks ft-box-links" :href="linkedinUrl">LinkedIn</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <!-- Second half -->
          <div class="w-full p02-second-half-container">
            <div class="h-1/2 flex justify-evenly">
              <div class="w-full flex items-center justify-center border border-[#E0DAD1]">
                <a href="https://www.lr.org/en/" rel="no-follow" class="footer-logo text-footerLinks ft-box-links" target="_blank">
                  <img src="@/images/footer/lloyds-register.svg" alt="Lloyds register">
                </a>
              </div>
              <div class="w-full flex items-center justify-center border border-[#E0DAD1]">
                <a href="https://www.iso.org/iso-9001-quality-management.html" rel="no-follow" class="footer-logo text-footerLinks ft-box-links" target="_blank">
                  <img src="@/images/footer/quality-systems-certification.svg" alt="Quality systems certification">
                </a>
              </div>
              <div class="w-full flex items-center justify-center border border-[#E0DAD1]">
                <a href="https://group.bureauveritas.com/" rel="no-follow" class="footer-logo text-footerLinks ft-box-links" target="_blank">
                  <img src="@/images/footer/bureau-veritas.svg" alt="Bureau veritas">
                </a>
              </div>
            </div>
            <div class="h-1/2 flex justify-evenly">
              <div class="w-full flex items-center justify-center border border-[#E0DAD1]">
                <a href="https://www.iso.org/iso-9001-quality-management.html" rel="no-follow" class="footer-logo text-footerLinks ft-box-links" target="_blank">
                  <img src="@/images/footer/quality-systems-certification.svg" alt="Quality systems certification">
                </a>
              </div>
              <div class="w-full flex items-center justify-center border border-[#E0DAD1]">
                <a href="https://www.iso.org/home.html" class="footer-logo text-footerLinks ft-box-links" target="_blank">
                  <img src="@/images/footer/iso-standard.svg" alt="ISO standard">
                </a>
              </div>
              <div class="w-full flex items-center justify-center border border-[#E0DAD1]">
                <a href="https://www.lr.org/en/" rel="no-follow" class="footer-logo text-footerLinks ft-box-links" target="_blank">
                  <img src="@/images/footer/lloyds-register.svg" alt="Lloyds register">
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>      
    </div>
  </div>
  <!-- Copyright -->
  <div class="bg-[#F9F8F6] w-full flex flex-row justify-center font-rubik">
    <div class="h-28 1350-bp:h-16 w-full max-w-1440">
      <div class="footer-inner-container border-l-2 border-r-2 border-[#E0DAD1] h-full flex flex-col 1350-bp:flex-row justify-between items-left 1350-bp:items-center text-sm 1350-bp:text-base gap-2 1350-bp:gap-0">
        <div class="pl-5 1350-bp:pl-0 flex flex-col 1350-bp:flex-row items-start justify-center gap-3">
          <div>
            <p class="all-rights-reserved-txt">© {{ currentYear }} Container Alliance. All rights reserved.</p>
          </div>
          <div class="flex 1350-bp:flex-row items-center justify-center gap-3 1350-bp:pb-0">
            <a class="text-footerLinks all-rights-reserved-txt" :href="codeOfEthicsUrl">Code of Ethics</a>
            <a class="text-footerLinks all-rights-reserved-txt" :href="copyrightUrl">Copyright</a>
            <a class="text-footerLinks all-rights-reserved-txt" :href="privacyPolicyUrl">Privacy Policy</a>
            <a class="text-footerLinks all-rights-reserved-txt" :href="termsOfUseUrl">Terms of Use</a>
            <a class="text-footerLinks all-rights-reserved-txt" :href="returnPolicy">Return Policy</a>
          </div>
        </div>
        <div class="border-[#E0DAD1] pl-5 1350-bp:pl-0 w-full h-full 1350-bp:w-auto flex items-start 1350-bp:items-center 1350-bp:justify-end gap-4 1350-bp:pr-6">
          <a :href="facebookUrl"><img src="@/images/social-media/facebook-rounded-black.svg" alt="facebook"></a>
          <a :href="instagramUrl"><img src="@/images/social-media/instagram-bottom.svg" alt="instagram"></a>
          <a :href="twitter"><img src="@/images/social-media/X.svg" alt="twitter"></a>
          <a :href="linkedinUrl"><img src="@/images/social-media/linkedin-solid.svg" alt="linkedin"></a>
        </div>
      </div>
    </div>
  </div>
</footer>
